import axios from "axios";
import { ScheduleChange } from "../types";

export const getScheduleChange = async (
  tripUuid: string,
  bookingUuid: string
) => {
  try {
    const { data } = await axios.get<ScheduleChange>(
      `${process.env.REACT_APP_API}/landing-page-proxy/api/schedule-change/approval/${tripUuid}/${bookingUuid}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};
